export default __webpack_public_path__ + "static/media/property_13.ff7932d2.png";